import {
    appleOandaFaviconLinks,
    oandaFaviconLinks,
} from '@/constants/favicon-icon';

export class OandaHelper {
    public static updateFavicon(): void {
        //update favicon for oanda page
        const faviconIcons: NodeListOf<Element> =
            document.querySelectorAll("link[rel~='icon']");
        const faviconMap = oandaFaviconLinks as Record<string, string>;
        for (const icon of faviconIcons) {
            if (icon.hasAttribute('sizes')) {
                const size = icon.getAttribute('sizes');
                if (size && faviconMap[size]) {
                    icon.setAttribute('href', faviconMap[size]);
                }
            } else {
                icon.setAttribute('href', oandaFaviconLinks.default);
            }
        }

        //update apple favicon for oanda page
        const appleIcons: NodeListOf<Element> = document.querySelectorAll(
            "link[rel~='apple-touch-icon']"
        );
        const appleFaviconMap = appleOandaFaviconLinks as Record<
            string,
            string
        >;
        for (const icon of appleIcons) {
            if (icon.hasAttribute('sizes')) {
                const size = icon.getAttribute('sizes');
                if (size && appleFaviconMap[size]) {
                    icon.setAttribute('href', appleFaviconMap[size]);
                }
            } else {
                icon.setAttribute('href', appleOandaFaviconLinks.default);
            }
        }
    }
}
